import './assets/scss/main.scss';
import './assets/styles/main.css';
import './assets/accessibility-tool/accessibility-widget.css';
import './assets/accessibility-tool/accessibility-widget.js';
import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import RequireAuth from './components/RequireAuth';
import PersistLogin from './components/PersistLogin';
import Login from './pages/LoginPage';
import HeaderLayout from './components/global/HeaderLayout';
import Loader from './components/FormsUI/Loader';
import { useOnlineStatus } from '../src/utility/useOnlineStatus';
import SignatoryLayout from './pages/Stepper/SignatoryLayout';

const RMLogin = React.lazy(() => import('./pages/RMLogin')); // Refactor Code
const SignatoryLogin = React.lazy(() => import('./pages/SignatoryLogin'));
const Register = React.lazy(() => import('./pages/Register'));
const Notfound = React.lazy(() => import('./pages/NotFound'));
const Stepper = React.lazy(() => import('./pages/Stepper/StepperSection'));
const Digilocker = React.lazy(() => import('./pages/Digilocker'));
const Esign = React.lazy(() => import('./pages/ESign'));
const ClientConsent = React.lazy(() => import('./pages/ClientConsent'));
const ConsentDetails = React.lazy(() => import('./pages/ConsentDetails'));
const EmailKYCPage = React.lazy(() => import('./pages/EmailKYC'));
const SessionTimeout = React.lazy(() => import('./pages/SessionTimeoutPage'));
const IPV = React.lazy(() => import('./pages/IPVDetailsRMFlow'));
const IPVSignatory = React.lazy(() => import('./pages/IPVDetails'));
const DocumentSignatory = React.lazy(() => import('./pages/DocumentsDetails'));
const SignatoryReview = React.lazy(() => import('./pages/ReviewDetails'));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
});

function App() {
  const isOnline = useOnlineStatus();
  return (
    <QueryClientProvider client={queryClient}>
      {!isOnline && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: 'red',
            color: 'white',
            padding: '10px',
            textAlign: 'center',
            zIndex: 9999,
          }}
        >
          ⚠️ You are offline. Please check your internet connection.
        </div>
      )}

      <div className="app">
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route element={<HeaderLayout />}>
              <Route path="/Login" element={<Login />}></Route>
              <Route path="/Register" element={<Register />}></Route>
              <Route path="/" element={<Register />}></Route>
              <Route path="/rmlogin" element={<RMLogin />}></Route>
              <Route path="/signatory-login" element={<SignatoryLogin />}></Route>
              <Route path="/mailkyc" element={<EmailKYCPage />}></Route>
              <Route path="/consent" element={<ClientConsent />}></Route>
              <Route
                path="/consent-details"
                element={
                  <SignatoryLayout>
                    <ConsentDetails />
                  </SignatoryLayout>
                }
              ></Route>
              <Route
                path="/signatory-documents"
                element={
                  <SignatoryLayout>
                    <DocumentSignatory />
                  </SignatoryLayout>
                }
              ></Route>
              <Route
                path="/signatory-ipv"
                element={
                  <SignatoryLayout>
                    <IPVSignatory />
                  </SignatoryLayout>
                }
              ></Route>
              <Route
                path="/signatory-review"
                element={
                  <SignatoryLayout>
                    <SignatoryReview />
                  </SignatoryLayout>
                }
              ></Route>
              <Route element={<PersistLogin />}>
                <Route element={<RequireAuth />}>
                  <Route path="kyc" element={<Stepper />} />
                  <Route path="digilocker" element={<Digilocker />} />
                  <Route path="esign" element={<Esign />} />
                  <Route path="ipv" element={<IPV />} />
                </Route>
              </Route>
            </Route>
            <Route path="/session-Timeout" element={<SessionTimeout />} />
            <Route path="*" element={<Notfound />} />
          </Routes>
        </Suspense>
      </div>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  );
}

export default App;
